import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';

var NormalList = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(NormalList, _React$Component);

  function NormalList() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = NormalList.prototype;

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h5", {
      className: "title"
    }, this.props.title), /*#__PURE__*/React.createElement("ul", {
      className: "items"
    }, this.props.items.map(function (item, index) {
      return /*#__PURE__*/React.createElement("li", {
        key: "list-" + index,
        className: "item",
        dangerouslySetInnerHTML: {
          __html: item
        }
      });
    })));
  };

  return NormalList;
}(React.Component);

export default NormalList;